export class HttpError extends Error {
  constructor(
    message: string,
    public status: number,
    // The server's machine-readable `code`, when it sent one.
    public code?: string
  ) {
    super(message)
    this.name = 'HttpError'
  }
}
